<div class="table-container">
  <table mdbTable class="z-depth-1">
    <thead>
      <tr>
        <th scope="col" [mdbTableSort]="data" sortBy="product">
          Product<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="units">
          Units<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="avg_price">
          Avg Price<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="subtotal">
          Sub Total<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="service_fees">
          Service Fees<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="tips">
          Tips<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="tip_percentage">
          Tip %<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="total">
          Total<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="redeemed">
          # Redeemed<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="redeemed_percentage">
          % Redeemed<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="revenue_percentage">
          % Revenue<mdb-icon fas icon="sort"></mdb-icon>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of data">
        <td scope="row">{{ element.product }}</td>
        <td scope="row">{{ element.units }}</td>
        <td scope="row">{{ element.avg_price | currency }}</td>
        <td scope="row">{{ element.subtotal | currency }}</td>
        <td scope="row">{{ element.service_fees | currency }}</td>
        <td scope="row" *ngIf="element.tips == 0">N/A</td>
        <td scope="row" *ngIf="element.tips != 0">
          {{ element.tips | currency }}
        </td>
        <td scope="row" *ngIf="element.tips != 0">
          {{ element.tip_percentage | percent }}
        </td>
        <td scope="row" *ngIf="element.tips == 0">N/A</td>
        <td scope="row">{{ element.total | currency }}</td>
        <td scope="row">{{ element.redeemed }}</td>
        <td scope="row">{{ element.redeemed_percentage | percent }}</td>
        <td scope="row">{{ element.revenue_percentage | percent }}</td>
      </tr>
    </tbody>
    <tfoot class="">
      <tr class="totals-row">
        <td scope="row" class="left">TOTAL</td>
        <td scope="row">{{ tUnits }}</td>
        <td scope="row">{{ tAvgPrice | currency }}</td>
        <td scope="row">{{ tSubtotal | currency }}</td>
        <td scope="row">{{ tServiceFees | currency }}</td>
        <td scope="row">{{ tTips | currency }}</td>
        <td scope="row">{{ tTipPercentage | percent }}</td>
        <td scope="row">{{ tTotal | currency }}</td>
        <td scope="row">{{ tRedeemed }}</td>
        <td scope="row">{{ tRedeemedPercentage | percent }}</td>
        <td scope="row" class="right">{{ tRevenue | percent }}</td>
      </tr>
    </tfoot>
  </table>
</div>
